import { SaleStatus } from '@/types/api/sale/sale-status.enum';
import { AppError } from './app-error';
import { ErrorCode } from '@/types/error-code.enum';

export function validateSaleStatus(status?: SaleStatus) {
  if (status !== undefined && status !== SaleStatus.Active) {
    throw new AppError('Sale is not active', ErrorCode.SaleNotActive, {
      saleId: undefined,
      status: status,
    });
  }
}
